import TerminatedUserBanner from './TerminatedUserBanner';
import FrozenUserBanner from './FrozenUserBanner';
import RewardsAvailableBanner from './RewardsAvailableBanner';
import MaintenanceBanner from './MaintenanceBanner';

export const BannersContainer = () => (
  <>
    <MaintenanceBanner />
    <TerminatedUserBanner />
    <FrozenUserBanner />
    <RewardsAvailableBanner />
  </>
);
